module.exports = __webpack_public_path__ + "static/media/picture-(67).eb495482.JPG";